export default __webpack_public_path__ + "static/media/game_logo.min.f419a339.png";